import { graphql, useStaticQuery } from 'gatsby'
import React, { type ReactElement } from 'react'

import Image from '@/components/image/image'

import * as styles from './styles.module.scss'

type SeparatorImages = {
  imageAlondra: {
    readonly url: string
  }
  imageGidp: {
    readonly url: string
  }
  imageGidpBlue: {
    readonly url: string
  }
}
const SeparatorSection = (
  props: Queries.SeparatorSectionFragment
): ReactElement | null => {
  const { separatorType } = props
  const data: SeparatorImages = useStaticQuery(graphql`
    query separatorDefaultImage {
      imageAlondra: datoCmsAsset(originalId: { eq: "oOhrbal2SCa7qb_8d9ujlw" }) {
        url
      }
      imageGidp: datoCmsAsset(originalId: { eq: "Of26Rnk1Sb-yBvYG-rq-GA" }) {
        url
      }
      imageGidpBlue: datoCmsAsset(
        originalId: { eq: "DwpRcOXyTTWLKs7UnHKhwg" }
      ) {
        url
      }
    }
  `)
  switch (separatorType) {
    case 'alondra':
      return (
        <div className={styles.separator}>
          <Image image={data?.imageAlondra} alt="visual separator" />
        </div>
      )
    case 'gidp':
      return (
        <div className={styles.separator}>
          <Image image={data?.imageGidp} alt="visual separator" />
        </div>
      )
    case 'gidp_blue':
      return (
        <div className={styles.separator}>
          <Image image={data?.imageGidpBlue} alt="visual separator" />
        </div>
      )
    default:
      return <hr />
  }
}

export default SeparatorSection

export const query = graphql`
  fragment SeparatorSection on DatoCmsSeparatorSection {
    __typename
    id
    separatorType
  }
`
